import React from 'react';
import type { SectionRefs } from '~/routes/blink';

export const NavBar = ({ refs }: { refs: SectionRefs }) => (
    <div className={'fixed top-0 z-20 hidden h-56 w-full items-center gap-8 p-12 pl-16 md:flex '}>
        <NavBarButton title="Hvordan fungerer det?" refObject={refs.howRef} />
        <NavBarButton title="Forhåndsvisning" refObject={refs.previewRef} />
        <NavBarButton title="Blink live" refObject={refs.liveRef} />
        <NavBarButton title="Nyheter" refObject={refs.updatesRef} />
        <NavBarButton title="Hva sier folk om Blink?" refObject={refs.quotesRef} />
        <NavBarButton title="FAQ" refObject={refs.faqRef} />
    </div>
);

const NavBarButton = ({ title, refObject }: { title: string; refObject: React.RefObject<HTMLDivElement> }) => (
    <button
        className="bg-blue-alt-900 font-medium rounded-32 h-full px-12 text-14 text-green-100 hover:bg-blue-900"
        onClick={() => scrollToRef(refObject)}>
        {title}
    </button>
);

function scrollToRef(scrollToRef: React.RefObject<HTMLDivElement>) {
    if (scrollToRef && scrollToRef.current) {
        scrollToRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }
}
